/**
 * Version 6
 * Highlights the active navigation link based on the current page URL.
 *
 * This script handles both top-level links and links nested inside <details> elements:
 * - If the link is inside a <details>, only the top-level summary is marked as active.
 * - Any submenu links inside the same <details> that are marked active are cleared.
 * - If the link is a top-level link outside of <details>, it is directly marked as active.
 */
document.addEventListener('DOMContentLoaded', () => {
    /** @type {HTMLElement|null} Navigation container */
    const nav = document.querySelector('.list-menu--inline')

    if (!nav) return // Exit if navigation menu does not load
    if (nav.querySelector('.active')) return // Exit if an active link already exists

    /** @type {NodeListOf<HTMLAnchorElement>} All anchor links in the navigation */
    const anchors = nav.querySelectorAll('a[href]')

    // Loop through each anchor to find a link matching the current URL
    anchors.forEach(a => {
        /** @type {string} Path of the anchor */
        const aPath = new URL(a.href).pathname

        /** @type {string} Current page path */
        const current_path = window.location.pathname

        if (aPath === current_path) {
            /** @type {HTMLDetailsElement|null} Closest <details> ancestor, if any */
            const parentDetails = a.closest('details')

            if (parentDetails) {
                // Activate only the top-level summary inside the <details>
                const summary = parentDetails.querySelector(
                    'summary.link, summary.list-menu__item.link, summary.header__menu-item.link'
                )

                if (summary) {
                    summary.classList.add('active')
                }
            } else {
                // Top-level link outside of <details>
                const topLink = a.closest('.link')
                if (topLink) topLink.classList.add('active')
            }
        }
    })
})